import { render, staticRenderFns } from "./performance.vue?vue&type=template&id=d2afdfbe&scoped=true&"
import script from "./performance.vue?vue&type=script&lang=js&"
export * from "./performance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2afdfbe",
  null
  
)

export default component.exports